







































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class GraficheList extends Vue {

    baseUrl: string = process.env.VUE_APP_URL;
    @Prop()
    resultsItemsGrafiche: any;

    get results() {
        return this.resultsItemsGrafiche;
    }

    @Prop()
    showLoadingGrafica: boolean;

    @Prop()
    codeSelected: string;

    mounted() {
    }

    getGraficheFromCapitolatoCodeAsync(codeSelected: string, isFirst: boolean) {
        this.$emit('getGraficheFromCapitolatoCodeAsync', codeSelected, isFirst)
    }
} 
